import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { ACTIVE_TAB } from '../../../shared/utils/constants';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      className="audit-tabpanel"
      role="tabpanel"
      hidden={value !== index}
      id={`audit-tabpanel-${index}`}
      aria-labelledby={`audit-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `audit-tab-${index}`,
    'aria-controls': `audit-tabpanel-${index}`,
  };
}

const AuditTab = ({ tabOne, tabTwo, tabOneLabel, tabTwoLabel, activeTab }) => {
  const [value, setValue] = React.useState(Number(ACTIVE_TAB.ZERO));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    activeTab(value);
  }, [value]);

  return (
    <div className="audit-tab">
      <div>
        <Tabs value={value} onChange={handleChange} aria-label="audit tabs">
          <Tab label={tabOneLabel} {...a11yProps(Number(ACTIVE_TAB.ZERO))} />
          <Tab label={tabTwoLabel} {...a11yProps(Number(ACTIVE_TAB.ONE))} />
        </Tabs>
      </div>
      <TabPanel value={value} index={Number(ACTIVE_TAB.ZERO)}>
        {tabOne}
      </TabPanel>
      <TabPanel value={value} index={Number(ACTIVE_TAB.ONE)}>
        {tabTwo}
      </TabPanel>
    </div>
  );
};

AuditTab.propTypes = {
  activeTab: PropTypes.func.isRequired,
  tabOne: PropTypes.node.isRequired,
  tabTwo: PropTypes.node.isRequired,
  tabOneLabel: PropTypes.node.isRequired,
  tabTwoLabel: PropTypes.node.isRequired,
};

export default withTranslation('common')(memo(AuditTab));
